import { requests } from '../../helper/agent';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form';
import { parseApiErrors } from '../../helper/apiUtils';
import {
  DEFAULT_CCSD_CODE_COST_LIST_ERROR,
  DEFAULT_CCSD_CODE_COST_LIST_RECEIVED,
  DEFAULT_CCSD_CODE_COST_LIST_REQUEST,
  DEFAULT_CCSD_CODE_COST_LIST_UNLOAD,
  DEFAULT_CCSD_CODE_COST_SINGLE_CREATE_REQUEST,
  DEFAULT_CCSD_CODE_COST_SINGLE_CREATE_SUCCESS,
  DEFAULT_CCSD_CODE_COST_SINGLE_REFRESHED,
  DEFAULT_CCSD_CODE_COST_LIST_ALL_LOADED,
} from '../constants';
import * as API_ROUTES from '../../routing/api';
import { hydraPageCount } from '../../helper/apiUtils';

export const defaultCcsdCodeCostListUnload = () => ({
  type: DEFAULT_CCSD_CODE_COST_LIST_UNLOAD,
});

const ITEMS_PER_PAGE = 250;

export const defaultCcsdCodeCostListFetch = (filters = {}) => {
  return (dispatch) => {
    dispatch({ type: DEFAULT_CCSD_CODE_COST_LIST_REQUEST });
    const fetchPage = (page) => {
      return requests
        .get(API_ROUTES.DEFAULT_CCSD_CODE_COSTS_LIST, { itemsPerPage: ITEMS_PER_PAGE, page, ...filters })
        .then((response) => {
          dispatch({ type: DEFAULT_CCSD_CODE_COST_LIST_RECEIVED, data: response });
          const totalPages = hydraPageCount(response);
          if (page < totalPages) {
            return fetchPage(page + 1);
          } else {
            dispatch({ type: DEFAULT_CCSD_CODE_COST_LIST_ALL_LOADED });
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            return dispatch(userLogout());
          }
          dispatch({ type: DEFAULT_CCSD_CODE_COST_LIST_ERROR, error });
        });
    };
    return fetchPage(1);
  };
};

export const defaultCcsdCodeCostCreateRequest = () => ({
  type: DEFAULT_CCSD_CODE_COST_SINGLE_CREATE_REQUEST,
});

export const defaultCcsdCodeCostSingleCreated = (data) => ({
  type: DEFAULT_CCSD_CODE_COST_SINGLE_CREATE_SUCCESS,
  data,
});

export const defaultCcsdCodeCostSingleRefresh = (iri) => {
  return (dispatch) => {
    return requests
      .get(iri)
      .then((response) => dispatch({ type: DEFAULT_CCSD_CODE_COST_SINGLE_REFRESHED, data: response }))
      .catch(() => {});
  };
};

export const defaultCcsdCodeCostSinglePatch = (id, data) => {
  return (dispatch) => {
    dispatch(defaultCcsdCodeCostCreateRequest());
    return requests
      .patch(id, data)
      .then((response) => {
        dispatch(defaultCcsdCodeCostSingleCreated(response));
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
